import type { AchievementKey } from "@frontier/content/achievements";
import { HULL_ART } from "./hull-art";
import { ALIEN_NPC_TEXTURES, npcAppearance, type NpcTextureKey } from "./game/npc-appearance";

const npcArt: Record<NpcTextureKey, string> = {
  raider: "/assets/combat/fighter.png", sniper: "/assets/combat/missile-boat.png",
  minelayer: "/assets/combat/minelayer.png", enemyHeavy: "/assets/enemy-heavy.png",
  support: "/assets/combat/heavy.png", enemy: "/assets/enemy.png",
  elite: "/assets/player-heavy.png", boss: "/assets/combat/boss.png", transport: "/assets/transport.png",
  ...ALIEN_NPC_TEXTURES,
};

export function AchievementArt({ target }: { target: AchievementKey }) {
  const src = target.category === "npc" ? npcArt[npcAppearance(target.kind).texture]
    : target.category === "pvp" ? HULL_ART[target.kind].src : "/assets/container.png";
  return <img className={`achievement-art ${target.category === "resource" ? `resource-${target.kind}` : ""}`} src={src} alt="" />;
}
